/* eslint-disable max-lines-per-function */
import { TarifgruppeSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/FixgehaltFields/TarifgruppeSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Standort } from '@/domain/mitarbeiter/features/anlageassistent/entities/Standort';
import { useTranslation } from 'react-i18next';

export function TarifvertragFields({ standort }: { standort: Standort }) {
  const form = useAnlageassistentFormContext();

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h2 className="text-neutrals-900 text-base font-bold leading-6">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.title',
          )}
        </h2>
        <span className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.description',
          )}
        </span>
      </div>
      <div className="flex flex-col gap-4">
        <div className="grid lg:grid-cols-2 gap-4 items-start ">
          <TarifgruppeSelect standort={standort} />
        </div>
        <form.Subscribe
          selector={(state) => ({
            tarifgruppe: state.values.bezahlung.bezahlungsart.tarifGruppe,
          })}>
          {({ tarifgruppe }) => {
            const selectedTarifgruppe =
              standort.tarifvertrag?.tarifgruppen.find(
                (tg) => tg.gruppe.toString() === tarifgruppe,
              );

            return (
              <div className="col-span-2 grid lg:grid-cols-2 gap-4 items-start">
                <form.AppField name="bezahlung.bezahlungsart.stundenlohn">
                  {(field) => (
                    <field.MoneyInput
                      disabled={!!selectedTarifgruppe}
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.stundenlohn.label',
                      )}
                      isRequired
                    />
                  )}
                </form.AppField>
                <form.AppField name="bezahlung.bezahlungsart.monatsgehalt">
                  {(field) => (
                    <field.MoneyInput
                      disabled={!!selectedTarifgruppe}
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.monatsgehalt.label',
                      )}
                    />
                  )}
                </form.AppField>
              </div>
            );
          }}
        </form.Subscribe>
      </div>
    </div>
  );
}
